import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from "src/core/services/data.service";
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class CurrencyListDataService extends DataService<typeof Model.General.Logic.ViewModels.CurrencySummary, Model.General.Logic.ViewModels.CurrencySummary, CurrencySummary> {
    protected map(entity: Model.General.Logic.ViewModels.CurrencySummary): CurrencySummary {
        return new CurrencySummaryModel(entity);
    }

    public static make(context?: any): CurrencyListDataService {
        return new CurrencyListDataService(context, ctx => ctx.CurrencySummaries);
    }
}

export class CurrencySummaryModel extends EntityModel<Model.General.Logic.ViewModels.CurrencySummary, CurrencySummary> implements CurrencySummary {

    @property<CurrencySummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<CurrencySummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;

    @property<CurrencySummaryModel>(o => o.entity.iso3Name, (o, value) => o.entity.iso3Name = value)
    public iso3Name: string;

	@property<CurrencySummaryModel>(o => o.entity.iso3NameCents, (o, value) => o.entity.iso3NameCents = value)
	public centsCurrency: string;


    @property<CurrencySummaryModel>(o => o.entity.symbol, (o, value) => o.entity.symbol = value)
    public symbol: string;

    @property<CurrencySummaryModel>(o => o.entity.decimalPlaces, (o, value) => o.entity.decimalPlaces = value)
    public decimalPlaces: number;

    @property<CurrencySummaryModel>(o => o.entity.format, (o, value) => o.entity.format = value)
    public format: string;

    @property<CurrencySummaryModel>(o => o.entity.isDefault, (o, value) => o.entity.isDefault = value)
    public isDefault: boolean;
}



// WEBPACK FOOTER //
// ./src/app/general/currencies/list/currency-list.data.ts